/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SessionInitResponseFromJSON } from '../models/index';
import * as runtime from '../runtime';
/**
 *
 */
export class SessionApi extends runtime.BaseAPI {
    /**
     * Reconcile subscription state and return degraded signal.  Cheap on re-opens: sync is skipped when lastSyncedAt is within RECONCILE_STALENESS_HOURS (default 6 h). Fallback on Stripe failure: returns last-known Firestore state + reason=sync_unavailable (never 5xx).  V2M-DEV-487 — this call is ATTRIBUTED to an account, in two places. Reaching this line already proves the extension mounted inside a real mailbox AND carried a valid token (the route is content-script-only and auth-required), which makes it the single most load-bearing activation signal the product has that no client-side consent decision can switch off. Until 2026-08-25 it left no account identifier anywhere: the only trace was the anonymous daily counter `daily_metrics.sessionInits`, so attributing real users\' mailbox opens to their accounts had to be done by joining Cloud Run logs on IP address and second. Now it writes (a) a structured log line carrying the uid, and (b) a durable per-user milestone (`mailbox_session_milestone.py`).
     * Session Init
     */
    async sessionInitV1SessionInitGetRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/session/init`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => SessionInitResponseFromJSON(jsonValue));
    }
    /**
     * Reconcile subscription state and return degraded signal.  Cheap on re-opens: sync is skipped when lastSyncedAt is within RECONCILE_STALENESS_HOURS (default 6 h). Fallback on Stripe failure: returns last-known Firestore state + reason=sync_unavailable (never 5xx).  V2M-DEV-487 — this call is ATTRIBUTED to an account, in two places. Reaching this line already proves the extension mounted inside a real mailbox AND carried a valid token (the route is content-script-only and auth-required), which makes it the single most load-bearing activation signal the product has that no client-side consent decision can switch off. Until 2026-08-25 it left no account identifier anywhere: the only trace was the anonymous daily counter `daily_metrics.sessionInits`, so attributing real users\' mailbox opens to their accounts had to be done by joining Cloud Run logs on IP address and second. Now it writes (a) a structured log line carrying the uid, and (b) a durable per-user milestone (`mailbox_session_milestone.py`).
     * Session Init
     */
    async sessionInitV1SessionInitGet(initOverrides) {
        const response = await this.sessionInitV1SessionInitGetRaw(initOverrides);
        return await response.value();
    }
}
